import React, {useEffect, useState} from "react";
import {
    IonPage,
    IonContent, IonLoading, IonIcon, IonRefresher, IonRefresherContent
} from "@ionic/react";
import AddJobFormModal from "../components/AddJobFormModal";
import AddJobCandidateProfileModal from "../components/AddJobCandidateProfileModal";
import {addCircle, cashOutline, locationOutline} from "ionicons/icons";
import {
    actionToGetJobDataById,
    actionToGetOtherUsersJobPostData, actionToGetOtherUsersJobProfileData,
    actionToGetUserJobPostData,
    actionToGetUserJobProfileData
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import JobCard from "../components/JobCard";
import JobDetailsSheetPopup from "../components/JobDetailsSheetPopup";
import {FacebookLoader} from "./Loader/FacebookLoader";
import JobPortalCandidateRoleComponentDesktop from "./JobPortalCandidateRoleComponentDesktop";
import {useParams} from "react-router";
import JobProfileCard from "./JobProfileCard";
import JobMembersToApplyComponents from "./JobMembersToApplyComponents";

export default function JobPortalDesktopDashboard({renderHeaderPage,isMobile}) {
    const [addJobModalSheet,setAddJobModalSheet] = useState(false);
    const [addJobProfileModalSheet,setAddJobProfileModalSheet] = useState(false);
    const [isOpenMainJobListPanel,setIsOpenMainJobListPanel] = useState(false);
    const [myJobPostsData,setMyJobPostsData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [selectedJobListUserType,setSelectedJobListUserType] = useState(1);
    const {
        userJobProfileData,setIsOpenCandidatesDeservingModel, userJobPostData, otherUsersJobPostData, setJobDetailsData, setIsJobDetailOpen,
        isJobDetailOpen,jobDetailsData,setDeservingCandidatesProfileData,otherUsersJobProfileData,isOpenCandidatesDeservingModel
    }= useStore();
    const {id} = useParams();

    const openJobCandidateProfileDetail = (jobProfile)=>{
        setIsOpenCandidatesDeservingModel(true);
        setDeservingCandidatesProfileData({...jobProfile});
    }

    useEffect(()=>{
        if(id) {
            actionToGetJobDataById(id).then((jobDetail)=>{
                if(jobDetail?.id) {
                    setJobDetailsData(jobDetail);
                    setIsJobDetailOpen(true);
                }
            });
            setTimeout(()=>{
                window.history.pushState({},null,`${window.location.origin}/dashboard/job-portal`);
            },1000)
        }
    },[id])


    const callFunctionToSelectJobPortalRole = (role)=>{
        setMyJobPostsData(true);
        if(role === 1){
            setAddJobModalSheet(true);
        }else{
            setAddJobProfileModalSheet(true);
        }
    }

    const openJobDetailPanel = (jobDetail)=>{
        setJobDetailsData(jobDetail);
        setIsJobDetailOpen(true);
    }

    const openMainJobListPanel = (myPosts,userType)=>{
        setMyJobPostsData(myPosts);
        setIsOpenMainJobListPanel(true);
        setSelectedJobListUserType(userType);
    }

    useEffect(() => {
        actionToGetUserJobProfileData();
        actionToGetUserJobPostData();
        actionToGetOtherUsersJobPostData();
        actionToGetOtherUsersJobProfileData();
    }, []);

    const handleRefresh = (event) => {
        actionToGetUserJobProfileData();
        actionToGetUserJobPostData();
        actionToGetOtherUsersJobPostData();
        actionToGetOtherUsersJobProfileData();
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="looking-for-page page-content">
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent pullingText="Pull to refresh" refreshingSpinner="circles"/>
                </IonRefresher>
                <div className={"main_inner_container_common_page mobile_inner_dashboard_page job_mob_d"}>
                    <div className={"desktop_in_detail_panel_main_cont"}>
                        <div className={"detail_dash_panel_left_side"}>
                            {/*//////////// my cv section //////////*/}
                            {(userJobProfileData?.loading) ?
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            My Job Profile
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        <div className="job-card my-job-profile">
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </div>
                                    </div>
                                </div>
                                :(userJobProfileData?.jobProfileData?.id) ?
                                    <div className={"verticel_scroll_container_outer"}>
                                        <div className={"h_in_v_card"}>
                                            <div className={"in_heading"}>
                                                My Job Profile
                                            </div>
                                            <div onClick={() => callFunctionToSelectJobPortalRole(2)} className={"view_all_action_button"}>
                                                Edit
                                            </div>
                                        </div>
                                        <div className={"verticel_scroll_container_inner"}>
                                            <div className="job-card my-job-profile">
                                                <div className="d-flex ion-align-items-center job-card-header">
                                                    <div className="company-icon-name">
                                                        {userJobProfileData?.jobProfileData?.name}
                                                    </div>
                                                    <div className={`approved_tag_section_tag ${userJobProfileData?.jobProfileData?.is_approved ? 'approved' : 'not_approved'}`}>
                                                        {userJobProfileData?.jobProfileData?.is_approved ? 'Approved' : 'Pending'}
                                                    </div>
                                                </div>
                                                <hr/>
                                                <div className="job-info"><h3>{userJobProfileData?.jobProfileData?.category}</h3>
                                                    <div className="company-rating">Preferred Work Type - {userJobProfileData?.jobProfileData?.work_type}</div>
                                                    <div className="company-rating">Current Salary - {userJobProfileData?.jobProfileData?.current_salary}</div>
                                                    <div className="job-meta">
                                                <span>
                                                <ion-icon
                                                    icon={locationOutline}
                                                    role="img" className="md hydrated"></ion-icon> {userJobProfileData?.jobProfileData?.location} &nbsp;|&nbsp;
                                                </span>
                                                        <span>
                                                <ion-icon
                                                    icon={cashOutline}
                                                    role="img" className="md hydrated"></ion-icon>{userJobProfileData?.jobProfileData?.expected_salary}</span>
                                                    </div>
                                                    <div className="tags-row">
                                                        <span className="job-tag">{userJobProfileData?.jobProfileData?.email}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className={"verticel_scroll_container_outer"}>
                                        <div className={"h_in_v_card"}>
                                            <div className={"in_heading"}>
                                                My Job Profile
                                            </div>
                                        </div>
                                        <div className={"verticel_scroll_container_inner"}>
                                            <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                                <div onClick={() => callFunctionToSelectJobPortalRole(2)} className={"add_data_button_n_v_Data"}>
                                                    <IonIcon icon={addCircle}/>
                                                    Upload CV
                                                </div>
                                                <div className={"message_no_j_d_but"}>
                                                    No CV Uploaded Yet!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                            {/*//////////// my cv section //////////*/}
                            <div className={"full_view_panel_add_container small_height"} id={"web-ad-banner-square"}>
                                Google adds will appear here
                            </div>
                        </div>
                        <div className={"detail_dash_panel_right_side"}>
                        {(userJobPostData?.loading) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Job Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className="job-card">
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </div>
                                    <div className="job-card">
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </div>
                                </div>
                            </div>
                            :(userJobPostData?.jobPostData?.length) ?
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            My Job Posts
                                            {(userJobPostData?.jobPostData?.length) && (
                                                <div onClick={() => callFunctionToSelectJobPortalRole(1)} className={"add_more"}>
                                                    <IonIcon icon={addCircle}/>
                                                    Add More
                                                </div>
                                            )}
                                        </div>
                                        <div onClick={()=>openMainJobListPanel(true,1)} className={"view_all_action_button"}>
                                            View All
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        {(userJobPostData?.jobPostData?.map((job)=>(
                                            <JobCard
                                                job={job}
                                                myJobPostsData={true}
                                                key={job.id}
                                                handleJobItemClick={openJobDetailPanel}
                                            />
                                        )))}
                                    </div>
                                </div>
                                :
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            My Job Posts
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                            <div onClick={() => callFunctionToSelectJobPortalRole(1)} className={"add_data_button_n_v_Data"}>
                                                <IonIcon icon={addCircle}/>
                                                Add Job
                                            </div>
                                            <div className={"message_no_j_d_but"}>
                                                No Job Posted Yet!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        <hr/>
                        {/*///////////// ALL POST DATA //////////////////*/}
                        {(otherUsersJobPostData?.loading) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Job Posts
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className="job-card">
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </div>
                                    <div className="job-card">
                                        <FacebookLoader type={"facebookStyle"} item={1}/>
                                    </div>
                                </div>
                            </div>
                            :(otherUsersJobPostData?.jobPostData?.length) ?
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            Other Job Posts
                                        </div>
                                        <div onClick={()=>openMainJobListPanel(false,1)} className={"view_all_action_button"}>
                                            View All
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        {(otherUsersJobPostData?.jobPostData?.map((job)=>(
                                            <JobCard
                                                job={job}
                                                key={job.id}
                                                handleJobItemClick={openJobDetailPanel}
                                            />
                                        )))}
                                    </div>
                                </div>
                                :
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            Other Job Posts
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                            <div className={"message_no_j_d_but"}>
                                                No Job Posted Yet!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {/*///////////// ALL POST DATA //////////////////*/}

                            {/*///////////// ALL POST DATA //////////////////*/}
                            {(otherUsersJobProfileData?.loading) ?
                                <div className={"verticel_scroll_container_outer"}>
                                    <div className={"h_in_v_card"}>
                                        <div className={"in_heading"}>
                                            Other Candidate Profiles
                                        </div>
                                    </div>
                                    <div className={"verticel_scroll_container_inner"}>
                                        <div className="job-card">
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </div>
                                        <div className="job-card">
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </div>
                                    </div>
                                </div>
                                :(otherUsersJobProfileData?.jobProfileData?.length) ?
                                    <div className={"verticel_scroll_container_outer"}>
                                        <div className={"h_in_v_card"}>
                                            <div className={"in_heading"}>
                                                Other Candidate Profiles
                                            </div>
                                            <div onClick={()=>openMainJobListPanel(false,2)} className={"view_all_action_button"}>
                                                View All
                                            </div>
                                        </div>
                                        <div className={"verticel_scroll_container_inner"}>
                                            {(otherUsersJobProfileData?.jobProfileData?.map((jobProfileData)=>(
                                                <JobProfileCard
                                                    key={jobProfileData?.id}
                                                    jobProfileData={jobProfileData}
                                                    openJobCandidateProfileDetail={openJobCandidateProfileDetail}
                                                />
                                            )))}
                                        </div>
                                    </div>
                                    :
                                    <div className={"verticel_scroll_container_outer"}>
                                        <div className={"h_in_v_card"}>
                                            <div className={"in_heading"}>
                                                Other Candidate Profiles
                                            </div>
                                        </div>
                                        <div className={"verticel_scroll_container_inner"}>
                                            <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                                <div className={"message_no_j_d_but"}>
                                                    No Job Posted Yet!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                            {/*///////////// ALL POST DATA //////////////////*/}
                    </div>
                    </div>
                </div>
            </IonContent>

            {/*/////// JOB POSTING //////////////*/}
            {(addJobModalSheet) ?
            <AddJobFormModal isOpen={addJobModalSheet}
                             fromJobList={true}
                             myJobPostsData={myJobPostsData}
                             onClose={() => setAddJobModalSheet(false)}
                             setIsLoading={setIsLoading}/>
                :''
            }
            {/*/////// JOB POSTING //////////////*/}

            {/*/////// JOB CANDIDATE PROFILE //////////////*/}
            {(addJobProfileModalSheet) ?
            <AddJobCandidateProfileModal isOpen={addJobProfileModalSheet}
                                         onClose={() => setAddJobProfileModalSheet(false)}
                                         setIsLoading={setIsLoading}
                                         selectedUserType={2}
                                         dataForEditing={userJobProfileData?.jobProfileData}/>
                :''
            }
            {/*/////// JOB CANDIDATE PROFILE //////////////*/}


            {(isJobDetailOpen) ?
            <JobDetailsSheetPopup isOpen={isJobDetailOpen}
                                  jobDetailsData={jobDetailsData}
                                  isMobile={isMobile}
                                  onDidDismiss={() => setIsJobDetailOpen(false)}/>
                :''
            }

            {(isOpenMainJobListPanel) ?
            <JobPortalCandidateRoleComponentDesktop
                isOpen={isOpenMainJobListPanel}
                myJobPostsData={myJobPostsData}
                selectedJobListUserType={selectedJobListUserType}
                setJobDetailsData={setJobDetailsData}
                jobDetailsData={jobDetailsData}
                onDidDismiss={() => setIsOpenMainJobListPanel(false)}
            />:''
            }
            {/*/////// JOB CANDIDATES DESERVING //////////////*/}
            {(isOpenCandidatesDeservingModel) ?
                <JobMembersToApplyComponents isOpen={isOpenCandidatesDeservingModel} />
                :''
            }
            {/*/////// JOB CANDIDATES DESERVING //////////////*/}
            <IonLoading isOpen={isLoading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    )
}
